import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import IconContainer from './icon_container';

export default function EmailIcon({ className }) {
  return (
    <IconContainer className={classnames('emailIconContainer', className)} viewBox="0 0 14 13">
      <g className="emailIcon" fill="currentColor" fillRule="evenodd">
        <polygon points="6.621504 0.600127251 6.621504 6.56313076 5.472064 5.4223214 5.019584 5.87215532 6.939584 7.77774596 8.862784 5.87088281 8.410304 5.41977637 7.261504 6.55931322 7.261504 0.600127251" />
        <path d="M10.416512,7.64514994 L12.591232,7.64705871 L12.591232,11.6637511 L1.411072,11.6631149 L1.408512,7.64642246 L3.542272,7.64769497 C3.686272,8.65361778 5.020672,10.0648365 6.964352,10.0648365 C8.908672,10.0648365 10.260352,8.65043649 10.416512,7.64514994 L10.416512,7.64514994 Z M2.013952,6.84346573 L1.802752,6.84282947 L2.013952,6.84346573 Z M9.651712,6.84282947 L9.643392,7.23603649 C9.638272,7.44282012 8.900992,9.26124351 6.964352,9.26124351 C5.033472,9.26124351 4.322432,7.4504552 4.320512,7.24367158 L4.317312,6.84410199 L2.821632,6.84346573 L0.600192,6.84155696 L0.600832,6.84282947 L0.600192,6.84282947 L0.603392,12.4667078 L13.398912,12.4673441 L13.398912,6.86955228 L9.708032,6.86955228 L9.708032,6.84282947 L9.651712,6.84282947 Z" />
      </g>
    </IconContainer>
  );
}

EmailIcon.propTypes = {
  className: PropTypes.string,
};
